import React, { useMemo } from "react";
import Failed_to_Load_Image from "images/wow/WowIcon.png";
import classNames from "classnames";

const Icon = (props) => {
  const { staticDataImg, talentTreeGreyout, talentSelectedNumber, talentMaxNumber, isInnerBorderPresent, spriteData, style } =
    props;
  // WHEN RESIZING TREE: Change default iconSize
  let iconSize = props.iconSize ? props.iconSize : "32px";
  let color = props.color ? props.color : "#25254B";
  let classType = props.classType ? props.classType : "";

  if (talentTreeGreyout === null) {
    talentTreeGreyout = false;
  }

  const className = classNames({
    "wow-icon-talent-inner-border": isInnerBorderPresent && !talentTreeGreyout,
    "wow-icon-talent-inner-border-greyout": isInnerBorderPresent && talentTreeGreyout,
    "wow-icon-talent-image": !isInnerBorderPresent && !talentTreeGreyout,
    "wow-icon-talent-image-greyout": !isInnerBorderPresent && talentTreeGreyout,
  });

  const size = useMemo(() => Number.parseInt(iconSize.slice(0, -2)), [iconSize]);

  return (
    <div
      className={classNames("wow-icon", classType, props.className, {
        "black-inset": isInnerBorderPresent,
      })}
      style={{
        color: color,
        width: iconSize,
        height: iconSize,
        minWidth: iconSize,
        minHeight: iconSize,
      }}
    >
      <div style={{ background: "#11112A", zIndex: isInnerBorderPresent && -50 }}>
        {spriteData ? (
          <div
            className={className}
            style={{
              height: spriteData.height,
              width: spriteData.width,
              backgroundImage: `url(${staticDataImg})`,
              backgroundPosition: `-${spriteData.left}px -${spriteData.top}px`,
              transform: `scale(${size / spriteData.height})`,
              ...style,
            }}
          />
        ) : (
          <img src={staticDataImg ?? Failed_to_Load_Image} className={className} />
        )}
      </div>
      {talentSelectedNumber !== undefined ? (
        <div className="wow-icon-talent-number">
          {talentSelectedNumber}/{talentMaxNumber}
        </div>
      ) : null}
    </div>
  );
};

export default Icon;
